<!-- <ng-container *ngIf="properties.name === 'Zona 1' || properties.name === 'Zona 2' " tabindex="0" cdkTrapFocus>
  <div class="container">
    <div class="calendar d-flex fd-col">
      <div class="d-flex fd-row">
        <sit-icon
          [icon]="Icon.schedule_lv"
          [sizeClass]="'icon-size-48'"
        ></sit-icon>
        <div class="d-flex fd-col">
          <span class="text-color-secondary-1 text-p">Lunes a viernes no festivos</span>
          <span class="text-white" *ngIf="properties.name === 'Zona 1' ">7:30h - 11:00h y 16:30h - 19:00h</span>
          <span class="text-white" *ngIf="properties.name === 'Zona 2' ">8:00h - 12:00h y 16:30h - 19:00h</span>
        </div>
      </div>
      <div class="d-flex fd-row">
        <sit-icon
          [icon]="Icon.schedule_s"
          [sizeClass]="'icon-size-48'"
        ></sit-icon>
        <div class="d-flex fd-col">
          <span class="text-color-secondary-1 text-p">Sábados no festivos</span>
          <span class="text-white" *ngIf="properties.name === 'Zona 1' ">7:30h - 11:00h</span>
          <span class="text-white" *ngIf="properties.name === 'Zona 2' ">8:00h - 12:00h</span>
        </div>
      </div>
    </div>
    <div class="time-max d-flex fd-row">
      <sit-icon class="pl-md-10-pt"
        [icon]="Icon.schedule_y"
        [sizeClass]="'icon-size-48'"
      ></sit-icon>
      <div class="d-flex fd-col">
        <div class="d-flex fd-col">
          <span class="text-color-secondary-1 text-p">Duración máxima en la plaza</span>
          <span class="text-white">30 minutos</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="properties.name === 'Zona 3' " tabindex="0" cdkTrapFocus>
  <div class="container">
    <div class="calendar d-flex fd-col">
      <div class="d-flex fd-row">
        <sit-icon
          [icon]="Icon.schedule_lv"
          [sizeClass]="'icon-size-48'"
        ></sit-icon>
        <div class="d-flex fd-col">
          <span class="text-color-secondary-1 text-p">Lunes a viernes no festivos</span>
          <span class="text-white">8:00h - 13:00h y 16:30h - 20:30h</span>
        </div>
      </div>
    </div>
    <div class="time-max d-flex fd-row">
      <sit-icon class="pl-md-10-pt"
        [icon]="Icon.schedule_y"
        [sizeClass]="'icon-size-48'"
      ></sit-icon>
      <div class="d-flex fd-col">
        <div class="d-flex fd-col">
          <span class="text-color-secondary-1 text-p">Duración máxima en la plaza</span>
          <span class="text-white">45 minutos</span>
        </div>
      </div>
    </div>
  </div>
</ng-container> -->

<ng-container tabindex="0" cdkTrapFocus>
  <div class="container">
    <div class="d-flex fd-col">
      <div class="d-flex fd-row mt-15 mb-8 ml-4" >
        <sit-icon
          [icon]="Icon.sensor_id"
          [sizeClass]="'icon-size-28'">
        </sit-icon>
        <span class="text-white text-p ml-8">{{ properties.refDevice }} </span>
      </div>
      <div class="d-flex fd-row justify-between content-ocupation">
        <div class="d-flex fd-col">
          <h3 class="text-color-secondary-1 text-p text-md-size-35">{{properties.ocupation}} %</h3>
          <span class="text-color-secondary-1 text-p">Ocupación del día</span>
        </div>
        <div class="d-flex fd-col">
          <div class="d-flex fd-row align-items-flex-end">
            <sit-icon [icon]="Icon.clock_w" [sizeClass]="'icon-size-28'"></sit-icon>
            <h3 class="text-color-secondary-1 text-p text-md-size-35 ml-8">{{properties.modifiedAt | date:'HH:mm'}}</h3>
          </div>
          <span class=" text-color-secondary-1 text-p" [ngClass]="{
              'text-red': properties.status === 'occupied',
              'text-blue-o': properties.status === 'free'
            }">{{
              properties.status === 'occupied'
                ? 'Ocupado'
                : properties.status === 'free'
                  ? 'Disponible'
                  : 'Sin información'
            }}
          </span>
        </div>
      </div>

    </div>
  </div>
</ng-container>
